import React, { useEffect } from "react";
import * as S from "./PageWrapper.style";
import { UpgradeButton } from "./UpgradeButton";
import { TryForFreeBanner } from "./TryForFreeBanner";
import { usePlanFeature } from "~/hooks/usePlanFeature";
import { Limits } from "~/types/billing";
import { Notifications } from "~/components/notifications";
import { useMediaQuery } from "~/spocketUI/hooks/useMediaQuery";
import Modal from "~/spocketUI/components/Modal";
import { Plans } from "~/components/plans";
import { SHOW_PLANS_MODAL } from "~/spocketUI/helpers/customEvents";

interface IProps {
  children: React.ReactNode;
}

export const PageWrapper: React.FC<IProps> = ({ children = null }) => {
  const { isFeatureDisabled } = usePlanFeature();

  const isSettingsPage = location.pathname.includes("settings");
  const isNotMobile = useMediaQuery("tablet");
  const [showPlansModal, setShowPlansModal] = React.useState(false);

  // Show plans modal when user needs to upgrade
  useEffect(() => {
    const handleRequiresUpgrade = () => setShowPlansModal(true);
    // @ts-ignore
    window.addEventListener(SHOW_PLANS_MODAL, handleRequiresUpgrade);
    return () => {
      // @ts-ignore
      window.removeEventListener(SHOW_PLANS_MODAL, handleRequiresUpgrade);
    };
  }, []);

  return (
    <S.PageWrapper
      padding={isSettingsPage ? "24px 25px 58px" : "24px 92px 58px"}>
      <S.PageHeader>
        {isFeatureDisabled(Limits.PAID_PLAN) ? <UpgradeButton /> : null}
        {isNotMobile ? <Notifications /> : null}
      </S.PageHeader>
      <S.PageMaxWidth>
        <TryForFreeBanner />
        <>{children}</>
      </S.PageMaxWidth>

      <Modal
        hide={() => setShowPlansModal(!showPlansModal)}
        isShowing={showPlansModal}
        minWidth="80%">
        <Plans closeModal={() => setShowPlansModal(!showPlansModal)} />
      </Modal>
    </S.PageWrapper>
  );
};
